import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import AxiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getCars = createAsyncThunk('GET CARS', async (data, thunkAPI) => {
  let query = `?page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&booking_status=${data.bookingStatus}&provider_name=${data.provider}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&currency=${data.currency}&payment_gateway=${data.paymentGateway}&sorting=${data.sorting}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&cogs_paid_date=${data.cogsPaidDate}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}&payment_type=${data.paymentMethodTypes}&agency_id=${data?.agencyId}`;

  const response = await AxiosAdmin.get(`${URL.CAR}${query}`, thunkAPI);
  return response.data;
});

export const getCarDetails = createAsyncThunk('GET CAR DETAILS', async (data, thunkAPI) => {
  const response = await AxiosAdmin.get(`${URL.CAR}?id=${data.referenceNumber}`, thunkAPI);
  return response.data;
});

export const resendEmailConfirmation = createAsyncThunk('RESEND_CAR_EMAIL_CONFIRMATION', async (data, thunkAPI) => {
  const response = await AxiosAdmin.post(URL.RESEND_CAR_CONFIRMATION_EMAIL, data, thunkAPI);
  return response.data;
});

export const updateCarRemark = createAsyncThunk('UPDATE_CAR_REMARKS', async (data, thunkAPI) => {
  let requestData = {
    remark_id: data?.remark_id || "",
    remark: data?.remark,
  };
  const response = await AxiosAdmin.put(`${URL.BOOKING}?id=${data.referenceNumber}`, requestData, thunkAPI);
  return response.data;
});

export const updateCarBooking = createAsyncThunk('UPDATE_CAR_BOOKING', async (data, thunkAPI) => {
  const response = await AxiosAdmin.put(`${URL.BOOKING}?id=${data.referenceNumber}`, data, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  carData: null,
  carDetails: null,
};

export const carSlice = createSlice({
  name: 'car',
  initialState,
  reducers: {},
  extraReducers: {
    // get cars
    [getCars.pending]: (state) => {
      state.isLoading = true;
      state.carData = null;
    },
    [getCars.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.carData = action.payload.data;
    },
    [getCars.rejected]: (state, action) => {
      state.isLoading = false;
      state.carData = null;
      toast.error(action?.payload?.message);
    },

    // update car remarks
    [updateCarRemark.pending]: (state) => {
      state.isLoading = true;
    },
    [updateCarRemark.fulfilled]: (state) => {
      state.isLoading = false;
      toast.success('Car remarks updated successfully');
    },
    [updateCarRemark.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating car remarks');
    },
    // get activity Details
    [getCarDetails.pending]: (state) => {
      state.isLoading = true;
      state.carDetails = null;
    },
    [getCarDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.carDetails = action.payload.data;
    },
    [getCarDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.carDetails = null;
      toast.error(action?.payload?.message);
    },

    // resend hotel confirmation email
    [resendEmailConfirmation.pending]: (state) => {
      state.isLoading = true;
    },
    [resendEmailConfirmation.fulfilled]: (state) => {
      state.isLoading = false;
      // Handle success, e.g., show a success toast message
      toast.success('Email confirmation resent successfully');
    },
    [resendEmailConfirmation.rejected]: (state, action) => {
      state.isLoading = false;
      // Handle error, e.g., show an error toast message
      toast.error(action.payload?.message || 'Error resending email confirmation');
    },

    // update car booking
    [updateCarBooking.pending]: (state) => {
      state.isLoading = true;
    },
    [updateCarBooking.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateCarBooking.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating cogs data');
    },
  },
});

export default carSlice.reducer;
